import { Form } from 'semantic-ui-react';

import React from 'react';
import {
    AreaDeInteres,
    MediosDeInformacionOption,
    PersonaARegistrar,
    Promotor,
    RutOPasaporte,
} from '../tipos';
import RutPasaporte, { RutPasaporteDatos } from './RutPasaporte/RutPasaporte';

interface Props {
    mediosDeInformacion: MediosDeInformacionOption;
    promotores: Array<Promotor>;
    alPresionarRegistrar(datos: PersonaARegistrar): Promise<void>;
}

interface MedioDeInformacion {
    tipo: string;
    otro: string;
    promotor: string;
}

interface State {
    nombre: string;
    rutOPasaporte: RutOPasaporte;
    rutPasaporteFormulario: RutPasaporteDatos;
    areaDeInteres: AreaDeInteres | '';
    medioDeInformacion: MedioDeInformacion;
    registrando: boolean;
    rutEsValido: boolean;
    esPasaporte: boolean;
}
const stateInicial: State = {
    nombre: '',
    rutPasaporteFormulario: {
        tipo: 'rut',
        rut: '',
    },
    rutOPasaporte: {
        tipo: 'rut',
        valor: '',
    },
    areaDeInteres: '',
    medioDeInformacion: {
        tipo: '',
        otro: '',
        promotor: '1',
    },
    registrando: false,
    rutEsValido: false,
    esPasaporte: false,
};

class FormularioDeRegistro extends React.PureComponent<Props, State> {
    public state: State = stateInicial;

    public render() {
        const { alPresionarRegistrar, promotores } = this.props;

        const { nombre, rutPasaporteFormulario, areaDeInteres } = this.state;

        return (
            <Form
                onSubmit={() => {
                    alPresionarRegistrar({
                        nombre: this.state.nombre,
                        areaDeInteres: this.state.areaDeInteres as AreaDeInteres,
                        medioDeInformacion: this.state.medioDeInformacion,
                        rutOPasaporte: this.state.rutOPasaporte,
                    })
                        .then(() => this.reiniciarFormulario())
                        .catch();
                }}
            >
                <Form.Group>
                    <RutPasaporte
                        width={4}
                        rutPasaporte={rutPasaporteFormulario}
                        alCambiar={id => {
                            this.actualizarRutOPasaporte(id);
                            this.setState({ esPasaporte: id.tipo === 'pasaporte' });
                        }}
                        esValido={value => this.setState({ rutEsValido: value })}
                        ocultarPais
                        requerido
                    />
                    <Form.Input
                        width={3}
                        label='Nombre'
                        value={nombre}
                        fluid
                        required
                        onChange={(_e, { value }) => {
                            this.actualizarState('nombre', value);
                        }}
                    />
                    <Form.Select
                        width={3}
                        fluid
                        label='Área de interés'
                        required
                        options={[
                            { value: 'preu', text: 'Preuniversitario' },
                            { value: 'ingles', text: 'Inglés' },
                            { value: 'ambos', text: 'Ambas' },
                        ]}
                        value={areaDeInteres}
                        onChange={(_e, { value }) => {
                            this.actualizarState('areaDeInteres', value as string);
                        }}
                    />
                    <Form.Select
                        width={3}
                        loading={this.props.mediosDeInformacion.length === 0}
                        label='Medio de información'
                        fluid
                        required
                        options={this.props.mediosDeInformacion}
                        value={this.state.medioDeInformacion.tipo}
                        onChange={(_e, { value }) => {
                            this.actualizarMedioDeInformacion({
                                tipo: value as string,
                                otro: '',
                                promotor: '',
                            });
                        }}
                    />
                    {this.state.medioDeInformacion.tipo === 'otro' && (
                        <Form.Input
                            width={3}
                            label='Otro'
                            fluid
                            required
                            value={this.state.medioDeInformacion.otro}
                            onChange={(_e, { value }) => {
                                this.actualizarMedioDeInformacion({
                                    tipo: 'otro',
                                    otro: value,
                                    promotor: '',
                                });
                            }}
                        />
                    )}
                    {this.state.medioDeInformacion.tipo === 'promotor' && (
                        <Form.Select
                            width={3}
                            label='Promotor'
                            fluid
                            required
                            options={promotores.map(unPromotor => ({
                                key: unPromotor.id,
                                value: unPromotor.id,
                                text: unPromotor.nombre,
                            }))}
                            value={this.state.medioDeInformacion.promotor}
                            onChange={(_e, { value }) => {
                                this.actualizarMedioDeInformacion({
                                    tipo: 'promotor',
                                    promotor: value as string,
                                    otro: '',
                                });
                            }}
                        />
                    )}
                </Form.Group>

                <Form.Button
                    disabled={!this.camposSonValidos() || this.state.registrando}
                    primary
                    content='Registrar'
                />
            </Form>
        );
    }
    private readonly camposSonValidos = () => {
        const { state } = this;
        if (state.areaDeInteres === '') return false;
        if (state.nombre === '') return false;
        if (!state.rutEsValido) return false;

        if (state.medioDeInformacion.tipo === '') return false;
        switch (state.medioDeInformacion.tipo) {
            case 'promotor':
                if (state.medioDeInformacion.promotor === '') return false;
                break;
            case 'otro':
                if (state.medioDeInformacion.otro === '') return false;
                break;
            default:
                return true;
        }
        return true;
    };

    private readonly reiniciarFormulario = () => {
        this.setState({ ...stateInicial });
    };

    private readonly actualizarState = (campo: string, valor: string | number | boolean) => {
        this.setState(prevState => ({ ...prevState, [campo]: valor }));
    };

    private readonly actualizarRutOPasaporte = (datos: RutPasaporteDatos) => {
        let rutOPasaporte: {
            tipo: 'rut' | 'pasaporte';
            valor: string;
        };
        datos.tipo === 'rut'
            ? (rutOPasaporte = {
                  tipo: 'rut',
                  valor: datos.rut,
              })
            : (rutOPasaporte = {
                  tipo: 'pasaporte',
                  valor: datos.pasaporte,
              });

        this.setState({ rutOPasaporte, rutPasaporteFormulario: datos });
    };

    private readonly actualizarMedioDeInformacion = (datos: MedioDeInformacion) => {
        this.setState({ medioDeInformacion: datos });
    };
}

export default FormularioDeRegistro;



// WEBPACK FOOTER //
// ./src/modulos/Recepcion/TurnosYAtenciones/componentes/FormularioDeRegistro.tsx